module.exports = {"TXTWCL_Watch_Trailer":{"id":"TXTWCL_Watch_Trailer","defaultMessage":"Παρακολούθησε το trailer","flags":["TRACK"],"track":"Watch Trailer"}}